'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// eslint-disable-next-line import/prefer-default-export
var getWeekRange = function (week) {
    var startOfWeek = week.clone().startOf('week');
    var endOfWeek = week.clone().endOf('week');
    var endYear = endOfWeek.format('YYYY');
    var getWeekFormat = function (date) {
        return date.format('MMM') + " " + date.format('D');
    };
    return {
        text: getWeekFormat(startOfWeek) + " - " + getWeekFormat(endOfWeek) + ", " + endYear,
        startOfWeek: startOfWeek,
        endOfWeek: endOfWeek,
    };
};

exports.getWeekRange = getWeekRange;
